export default {"src":"/flights/assets/desktop/_next/static/media/bus.98956b51.svg","height":16,"width":16};